export type MajorRoute = "map" | "dashboard" | "integrity" | "station" | "site" | "space";

export function useRouteInfo() {
	const route = useRoute();

	const routesRegex: [MajorRoute, RegExp][] = [
		["map", /map/],
		["dashboard", /dashboard/],
		["integrity", /integrity/],
		["station", /stations/],
		["site", /sites/],
		["space", /spaces/],
	];

	const currentRoute = computed(() => {
		for (const [name, regex] of routesRegex) {
			if (regex.test(route.path)) {
				return name;
			}
		}

		return null;
	});

	const onMap = computed(() => currentRoute.value === "map");
	const onDashboard = computed(() => currentRoute.value === "dashboard");
	const onIntegrity = computed(() => currentRoute.value === "integrity");

	const onStation = computed(() => currentRoute.value === "station");
	const onSite = computed(() => currentRoute.value === "site");
	const onSpace = computed(() => currentRoute.value === "space");

	return {
		currentRoute,
		onMap,
		onDashboard,
		onIntegrity,
		onStation,
		onSite,
		onSpace,
	};
}
